<template>
  <el-menu
    router=True
    :default-active="activeIndex2"
    class="el-menu-demo"
    mode="horizontal"
    @select="handleSelect"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b">
    <el-menu-item class="el-menu-item" index="/">Home</el-menu-item>
    <el-menu-item class="el-menu-item" index="browse">Browse</el-menu-item>
    <el-menu-item class="el-menu-item" index="functionalities">functionalities</el-menu-item>
    <el-menu-item class="el-menu-item" index="deepfusion">DeepFusion</el-menu-item>
    <el-menu-item class="el-menu-item" index="download">Download</el-menu-item>
    <el-menu-item class="el-menu-item" index="about">About</el-menu-item>
    <el-menu-item class="el-menu-item" index="help">Help</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "PageHeader",
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>

<style scoped>
.el-menu-item{
  font-size: 20px;
  text-align: center;
  width:14%;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue